import { Link } from "react-router-dom";
import { Mail, Instagram, Linkedin, Coffee } from "lucide-react";
import { PageMeta } from "@/components/PageMeta";
import { ContentPageShell, Prose } from "@/components/ContentPageShell";

export default function Contact() {
  return (
    <>
      <PageMeta
        title="Kontakt — Tipomatic"
        description="Máte otázku, návrh nebo hlásíte chybu? Napište nám na hello@tipomatic.app. Ozýváme se zpravidla do 72 hodin."
        path="/contact"
      />
      <ContentPageShell>
        <h1 className="text-3xl md:text-4xl font-bold mb-6">Kontakt</h1>
        <Prose>
          <p>
            Tipomatic provozuje jednotlivec, ne firma. Nemáme call centrum a nemáme chatbota — dotazy čte a
            odpovídá skutečný člověk. Ozvěte se prosím jedním z níže uvedených kanálů. <strong>Doba odezvy je
            zpravidla do 72 hodin</strong>, ve dnech zápasů MS nebo ME většinou během několika hodin.
          </p>

          <h2>Preferovaný kanál — e-mail</h2>
          <p>
            Pro obecné dotazy, obchodní záležitosti (např. nabídka spolupráce), hlášení chyb a žádosti podle GDPR:
          </p>
          <p>
            <a href="mailto:hello@tipomatic.app" className="inline-flex items-center gap-2">
              <Mail className="h-4 w-4" /> hello@tipomatic.app
            </a>
          </p>
          <p>
            Pro rychlejší zpracování prosím do předmětu uveďte, čeho se dotaz týká (např. "Bug: tipy se neukládají",
            "GDPR: mazání účtu", "Spolupráce").
          </p>

          <h2>Hlášení bezpečnostních chyb</h2>
          <p>
            Pokud jste našli bezpečnostní zranitelnost (XSS, únik dat, obejití RLS…), pošlete detaily prosím na{" "}
            <a href="mailto:hello@tipomatic.app">hello@tipomatic.app</a> s předmětem začínajícím{" "}
            <strong>[security]</strong>. Prosíme, nezveřejňujte zjištění dokud opravu nenasadíme —
            responsible disclosure standardně do 30 dní.
          </p>

          <h2>Sociální sítě</h2>
          <p>Rychlé zprávy a novinky o vývoji sledujeme i tady:</p>
          <ul>
            <li>
              <a href="https://www.instagram.com/lukaspaiskr" target="_blank" rel="noopener noreferrer">
                <Instagram className="inline h-4 w-4 mr-1" /> Instagram @lukaspaiskr
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/lukaspaiskr" target="_blank" rel="noopener noreferrer">
                <Linkedin className="inline h-4 w-4 mr-1" /> LinkedIn — Lukáš Paiskr
              </a>
            </li>
          </ul>


          <h2>Podpořte projekt</h2>
          <p>
            Tipomatic je zdarma a plánujeme ho zdarma zachovat. Pokud vás baví, můžete přispět symbolickou částkou
            na provoz přes Buy me a Coffee:
          </p>
          <p>
            <a
              href="https://www.buymeacoffee.com/incubator"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#FFDD00] !text-black no-underline px-5 py-2.5 text-sm font-semibold"
            >
              <Coffee className="h-4 w-4" /> Koupit kávu
            </a>
          </p>
        </Prose>
      </ContentPageShell>
    </>
  );
}
